module.exports = window["core-js/modules/web.dom-collections.for-each.js"];